<template>
  <div
    v-if="initialLoading"
    class="journal-content-list-wrapper"
  >
    <slot />
  </div>
  <div
    v-else
    v-view-section-tracker="getSectionViewParams()"
    class="journal-content-list-wrapper"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
  import { storeToRefs } from 'pinia';
  import { computed, ref, watch } from 'vue';

  import { useViewTracker } from '@/services/analytics';
  import { useJournalContent } from '@/entities/journalContent';

  interface Props {
    /**
     * Идентификатор города.
     */
    subjectGeoId: number;

    /**
     * Название города.
     */
    subjectGeoName: string;

    /**
     * Флаг загрузки сторонних данных.
     *
     * Данный флаг нужен для того, чтобы не отсылать события аналитики до того
     * как загрузятся все данные, отправляемые в событиях.
     */
    generalPageDataLoading: boolean;
  }

  const props = defineProps<Props>();

  const journalContentEntity = useJournalContent();
  const { loading: journalContentLoading } = storeToRefs(journalContentEntity);
  const initialLoading = ref(true);
  const loading = computed(() => journalContentLoading.value || props.generalPageDataLoading);

  const vViewSectionTracker = useViewTracker('city-articles-info:section.view');

  const getSectionViewParams = () => ({
    subject_geo_id: props.subjectGeoId,
    subject_geo_name: props.subjectGeoName,
    subject_geo_type: 'city',
    section_type: 'article',
  });

  watch(
    () => loading.value,
    () => {
      if (!loading.value) {
        initialLoading.value = false;
      }
    },
  );
</script>
